/**
 * Created by Teo on 07/08/2019.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('userInfo', {
                parent: 'adminEmployeeView',
                url: '',
                data: {
                    authorities: ['ROLE_ADMIN', 'ROLE_MANAGEMENT','ROLE_SUPERVISOR', 'ROLE_ACCOUNTING_DEP', 'ROLE_REC_ADMINISTRATOR', 'ROLE_PHARM_SUPERVISOR'],
                    pageTitle: 'sigmaCrmApp.employee.home.title'
                },
                templateUrl: 'app/displays/adminEmployees/info/info.html',
                controller: 'AdminEmployeeViewInfoController',
                controllerAs: 'vm',
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    selectedEmployee: ['$http', '$stateParams', function ($http, $stateParams) {
                        return $http.get('api/employees/' + $stateParams.id).then(function (response) {
                            return response.data;
                        });
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('employee');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
